<template>
  <div class="list-box">
    <div class="top-box" id="topBox">
      <!-- 标题 -->
      <van-nav-bar ref="navBar" style="position: static;" :title="$route.meta.title" id="navBar">
        <template #left>
          <i class="icon-back" @click="onBack()"></i>
        </template>

        <template #right>
          <span class="search-box">search</span>
        </template>
      </van-nav-bar>
      <div class="top-tab-box">
        <span :class="{ on: tag == item }" @click="toList(item)" v-for="item, index in tagList"
          :key="index">{{ item }}</span>

      </div>

      <span class="tag-hint">Home / {{ tag }}</span>
      <div class="box-1">
        <span class="b1-title">Sort By：</span>
        <div class="selelct-sort-bay-box" id='selelctSortBayBox'>
          <popover class="v-popover-val" :get-container="getContainer" v-model="showPopover" trigger="click"
            :actions="actions">
            <span class="van-popover__action" :class="{ 'van-popover__action-on': item == actionsVal }"
              @click="actionsVal = item, showPopover = false" v-for="item, index in actions" :key="index">{{ item
              }}</span>
            <template #reference>
              <span class="popover-val" :class="{ 'popover-val-on': showPopover }">{{ actionsVal }}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                  <path
                    d="M7.9668 14.5341L10.0351 12.4658L18.0009 20.4317L25.9668 12.4658L28.0351 14.5341L18.0009 24.5683L7.9668 14.5341Z"
                    fill="#999999" />
                </svg>
              </span>
            </template>
          </popover>
        </div>

        <span class="filter-icon" :class="{ 'filter-icon-on': filterVal }" @click="showFilter = true">Filter
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <g clip-path="url(#clip0_293_1362)">
              <path
                d="M29.5187 1.73405C29.3039 1.26024 28.9561 0.859055 28.5176 0.579303C28.079 0.29955 27.5686 0.153294 27.0484 0.158329H2.88964C2.36984 0.155024 1.86016 0.301986 1.42192 0.581533C0.983674 0.861081 0.635541 1.2613 0.419406 1.73405C0.197384 2.20249 0.11542 2.72509 0.183373 3.23901C0.251325 3.75293 0.4663 4.23627 0.802442 4.6309L9.30262 14.7229V28.2415C9.30006 28.866 9.48255 29.4773 9.82708 29.9981C10.1716 30.519 10.6627 30.9262 11.2384 31.1682L17.3303 33.776C17.6899 33.9301 18.082 33.9925 18.4716 33.9577C18.8612 33.923 19.2362 33.7921 19.5628 33.5769C19.8894 33.3616 20.1575 33.0687 20.3431 32.7244C20.5287 32.3801 20.626 31.9951 20.6263 31.604V14.7297L29.1287 4.63778C29.4674 4.24322 29.6844 3.75898 29.7536 3.24365C29.8228 2.72832 29.7412 2.20397 29.5187 1.73405ZM17.5689 13.615V30.5489L12.438 28.3699C12.4157 28.3602 12.3966 28.3442 12.3832 28.3238C12.3698 28.3035 12.3625 28.2796 12.3623 28.2553V13.615L3.61443 3.21573H26.3213L17.5689 13.615ZM32.3169 27.4227H27.3626C27.1569 27.4147 26.9517 27.4483 26.7593 27.5216C26.5668 27.5948 26.3912 27.7061 26.2428 27.8489C26.0944 27.9916 25.9764 28.1628 25.8958 28.3523C25.8151 28.5417 25.7736 28.7455 25.7736 28.9514C25.7736 29.1573 25.8151 29.361 25.8958 29.5505C25.9764 29.7399 26.0944 29.9111 26.2428 30.0539C26.3912 30.1966 26.5668 30.3079 26.7593 30.3812C26.9517 30.4544 27.1569 30.488 27.3626 30.4801H32.3169C32.7121 30.4648 33.086 30.297 33.3602 30.012C33.6343 29.727 33.7875 29.3469 33.7875 28.9514C33.7875 28.5559 33.6343 28.1758 33.3602 27.8908C33.086 27.6057 32.7121 27.438 32.3169 27.4227ZM32.3169 20.8079H27.3626C26.9569 20.8079 26.5678 20.969 26.2809 21.2559C25.994 21.5428 25.8328 21.932 25.8328 22.3377C25.8328 22.7434 25.994 23.1326 26.2809 23.4195C26.5678 23.7064 26.9569 23.8676 27.3626 23.8676H32.3169C32.7226 23.8676 33.1117 23.7064 33.3986 23.4195C33.6855 23.1326 33.8467 22.7434 33.8467 22.3377C33.8467 21.932 33.6855 21.5428 33.3986 21.2559C33.1117 20.969 32.7226 20.8079 32.3169 20.8079Z"
                :fill="filterVal ? '#6937E3' : '#666666'" />
              <path
                d="M25.832 15.7342C25.8332 16.1396 25.9948 16.528 26.2815 16.8146C26.5681 17.1013 26.9565 17.2628 27.3619 17.264H32.3161C32.7219 17.264 33.111 17.1029 33.3979 16.816C33.6848 16.5291 33.846 16.1399 33.846 15.7342C33.846 15.3285 33.6848 14.9393 33.3979 14.6524C33.111 14.3655 32.7219 14.2043 32.3161 14.2043H27.3619C26.9561 14.2043 26.567 14.3655 26.2801 14.6524C25.9932 14.9393 25.832 15.3285 25.832 15.7342Z"
                :fill="filterVal ? '#6937E3' : '#666666'" />
            </g>
            <defs>
              <clipPath id="clip0_293_1362">
                <rect width="33.6842" height="33.8081" fill="white" transform="translate(0.158203 0.158447)" />
              </clipPath>
            </defs>
          </svg>
        </span>

      </div>
    </div>

    <div class="goods-box" id="goodsBox">
      <div class="gb-list" @click="toDetails" v-for="item, index in goodsList" :key="index">
        <div class="gb-pic">
          <img v-lazy="`${item.img}?imageView2/1/w/400/h/400`">
        </div>
        <span class="overflow">{{ item.title }}</span>
        <i>${{ $fn.initPrice(item.price, 0) }}<i>{{ $fn.initPrice(item.price, 1) }}</i></i>
      </div>
    </div>

    <div class="bottom-box">
      <div class="bottom-hint">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M31.875 17C31.875 8.78477 25.2152 2.125 17 2.125C8.78477 2.125 2.125 8.78476 2.125 17C2.125 25.2152 8.78476 31.875 17 31.875C25.2152 31.875 31.875 25.2152 31.875 17ZM18.0625 8.50064V20.1875H15.9375V8.50064H18.0625ZM15.7129 23.375H18.2629V25.925H15.7129V23.375Z"
              fill="#FF7D00" />
          </svg>
          <span>
            正在预览“克隆后的外贸网站”，内容仅供参考，非上线效果！
          </span>
        </div>
        <div>
          <span @click="$router.push('/advert/advert1')">去克隆我的外贸网站</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M13.7288 26.4768L11.7754 24.5234L19.2987 17.0001L11.7754 9.47681L13.7288 7.52342L23.2055 17.0001L13.7288 26.4768Z"
              fill="#FF7D00" />
          </svg>
        </div>
      </div>
    </div>

    <filterPopup v-model="showFilter" :data="filterList"
      @onDone="(e) => { filterVal = e.filterVal, filterList = e.arr }">
    </filterPopup>
  </div>

</template>
<script>
import filterPopup from './filterPopup.vue';
import { Popover } from 'vant';
export default {
  name: 'MakerList',
  components: {
    Popover, filterPopup
  },
  props: {},
  data() {
    return {
      showFilter: false,
      tag: '',
      tagList: ['Rings', 'Pendants', 'Chains', 'Earrings', 'Necklaces', 'Bracelets', 'Anklets', 'Nose Studs', 'Sets', 'Toe Rings', 'Clearance'],
      showPopover: false,
      actionsVal: 'Recommend',
      actions: ['Most Popular', 'New Arrivals', 'Recommend', 'Top Rated', 'Price Low to High', 'Price High to Low'],
      goodsList: [
        {
          img: 'https://xhdata.wan4.com/wsw-pc-131.png',
          title: 'Wholesale Irregular Texture Hollow...',
          price: '311'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-126.png',
          title: 'Wholesale Cute Christmas Jewelry...',
          price: '149'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-127.png',
          title: 'Hot Sale Stainless Steel Christmas...',
          price: '226'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-128.png',
          title: 'Trendy Brass Colorful Zircon Christ...',
          price: '447'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-129.png',
          title: 'Trendy Wholesale Jewelry Christm...',
          price: '178'
        }, {
          title: 'New Arrival Jewelry Copper Christ...',
          img: 'https://xhdata.wan4.com/wsw-pc-160.png',
          price: '410',
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-130.png',
          title: 'Cute Jewelry Christmas Zircon Glo...',
          price: '277'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-146.png',
          title: 'Trendy Fine Jewelry 925 Silver He...',
          price: '2519'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-147.png',
          title: 'Wholesale Cutout Design Geometr...',
          price: '$99'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-133.png',
          title: 'Wholesale Sun Planet Inlaid Fritillas...',
          price: '180'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-134.png',
          title: 'Wholesale Bow-Shaped Tassel Lin...',
          price: '249'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-148.png',
          title: 'Wholesale Polished Craft Heart Sh...',
          price: '177'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-135.png',
          title: 'Wholesale Personalized Texture De...',
          price: '282'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-136.png',
          title: 'Wholesale Geometric Embossed W...',
          price: '260'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-149.png',
          title: 'Wholesale Stainless Steel Geomet...',
          price: '265'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-150.png',
          title: 'Wholesale Fried Dough Twists Thr...',
          price: '247'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-151.png',
          title: 'Wholesale Stainless Steel Grade G...',
          price: '249'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-152.png',
          title: 'Wholesale Wings Shaped Earring...',
          price: '124'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-153.png',
          title: 'Wholeslae Irregular Shape Unique...',
          price: '249'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-154.png',
          title: 'Wholesale Factory Circle Polka Do...',
          price: '249'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-155.png',
          title: 'Hot Sale Geometric Stainless Steel...',
          price: '249'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-156.png',
          title: 'Wholesale Popular Brilliant Cut Zir...',
          price: '175'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-157.png',
          title: 'Wholesale U-shaped Hollow Inlaid...',
          price: '252'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-158.png',
          title: 'Hot Sale Round High Quality Gold...',
          price: '173'
        }, {
          img: 'https://xhdata.wan4.com/wsw-pc-159.png',
          title: 'Wholesale Unique Oval Shaped Ac...',
          price: '260'
        },
      ],

      filterList: [
        {
          title: 'Categories',
          subList: [
            'stud earrings', 'dangle earrings', 'hoop earrings', 'Drop Earrings'
          ]
        },
        {
          title: 'Styles',
          subList: [
            'Simple', 'Retro', 'Classic', 'TRENDY', 'Vintage', 'Punk', 'Casual/Sporty', 'BOHEMIA', 'Elegant', 'Luxury'
          ]
        },
        {
          title: 'Pattern',
          subList: [
            'Heart', 'Flower', 'Butterfly', 'Letter', 'Geometric', 'Cross', 'Wings', 'Animal', 'Water Drop', 'Star', 'Leaf', 'Pumpkin', 'Christmas Tree', 'Santa Claus', 'Christmas', 'Bell', 'Gingerbread Man'
          ]
        },
        {
          title: 'Material',
          subList: [
            'Copper', '304 Stainless Steel', 'Brass', '925silver'
          ]
        },
        {
          title: 'Plating Material',
          subList: [
            '18K Gold Plated', '14K Gold Plated', 'White Gold Plated', 'Black Gun Plated'
          ]
        },
        {
          title: 'Insert Material',
          subList: [
            'Natural Stone', 'Artificial Pearl', 'ZIRCON', 'Shell', 'Moissanite'
          ]
        },
        {
          title: 'Rrice Range',
          subList: []
        },
        {
          title: 'Min.Stock',
          subList: []
        }
      ],
      filterVal: '',
    }
  },

  created() {
    this.tag = this.$route.query.tag
    this.$nextTick(() => {
      document.getElementById('goodsBox').style.marginTop = document.getElementById('topBox').offsetHeight + 'px';
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.showFilter) {
      this.showFilter = false;
      next(false)
    } else {
      next()
    }
  },
  methods: {
    getContainer() {
      return document.getElementById('selelctSortBayBox');
    },
    onBack() {
      this.$router.back()
    },
    toList(tag) {
      this.tag = tag;
    },
    toDetails() {
      this.$router.push('/maker/details')
    }
  }
}
</script>
<style lang="less" scoped>
.search-box {
  width: 199px;
}

.list-box {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding-bottom: calc(96px + env(safe-area-inset-bottom));

  .top-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    z-index: 1;
    background: #fff;
  }

  .top-tab-box {
    display: flex;
    height: 78px;
    align-items: center;
    padding: 0 24px;
    overflow-x: scroll;
    scrollbar-width: none;
    /* 对于 Firefox 隐藏滚动条 */

    &::-webkit-scrollbar {
      display: none;
      /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px;
      margin-right: 34px;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }

    .on {
      color: #6937E3;
      font-weight: bold;
    }
  }

  .tag-hint {
    margin: 4px 24px 18px;
    color: #666;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
  }

  .box-1 {
    height: 104px;
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
    width: 100vw;
    display: flex;
    align-items: center;

    .b1-title {
      overflow: hidden;
      color: #111;
      text-overflow: ellipsis;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px;
      margin-left: 24px;
    }

    .filter-icon {
      margin-left: auto;
      margin-right: 32px;
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      display: flex;
      align-items: center;

      >svg {
        width: 33.684px;
        height: 33.684px;
        margin-left: 10px;
      }

      &-on {
        color: #6937E3;
      }
    }

  }

  .goods-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px;
    background: #fff;
    padding: 28px 24px 0;

    .gb-list {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
      border-radius: 12px;

      .gb-pic {
        width: 100%;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          display: block;
          padding-bottom: 100%;
          /* 使高度等于宽度 */
        }

        >img {
          width: calc(100% + 4px);
          height: calc(100% + 4px);
          position: absolute;
          top: -2px;
          left: -2px;
        }
      }

      >span {
        color: #333;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
        margin-left: 10px;
      }

      >i {
        color: #F53F3F;
        font-family: Arial;
        font-size: 34px;
        font-style: normal;
        font-weight: 700;
        line-height: 48px;
        margin-top: 6px;
        margin-left: 10px;
        margin-bottom: 18px;

        >i {
          color: #F53F3F;
          font-family: Arial;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 48px;
        }
      }
    }
  }

  .bottom-box {
    position: fixed;
    padding-bottom: calc(env(safe-area-inset-bottom));
    bottom: 0;
    background: #fff;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;

    .bottom-hint {
      background: #FFE4BA;
      display: flex;
      flex-direction: column;
      padding: 12px 26px;

      >div {
        display: flex;
        align-items: center;

        >svg {
          width: 34px;
          height: 34px;
        }

        >span {
          color: #FF7D00;
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;
          margin-left: 10px;
        }
      }

      >div+div {
        justify-content: center;
        margin-top: 4px;

        >span {
          text-decoration-line: underline;
        }
      }
    }
  }
}

::v-deep .selelct-sort-bay-box {
  position: relative;
  display: flex;

  .v-popover-val {
    display: flex;
  }

  .popover-val {
    border-radius: 4px;
    border: 2px solid #DCDCDC;
    background: #FFF;
    width: 320px;
    height: 68px;
    overflow: hidden;
    color: #111;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding-left: 24px;

    >svg {
      width: 36px;
      height: 36px;
      margin-left: auto;
      margin-right: 16px;
      transition: 0.3s;
    }

    &-on {
      border: 2px solid #6937E3;

      >svg {
        transform: rotate(180deg);
      }
    }
  }

  .van-popover {
    width: 400px;
    left: 0 !important;
    top: 72px !important;

    .van-popover__arrow {
      display: none;
    }

    .van-popover__content {
      border-radius: 8px;
      border: 2px solid #DCDCDC;
      background: #FFF;
      box-shadow: 0px 4px 12px -8px rgba(0, 0, 0, 0.08), 0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 12px 56px -16px rgba(0, 0, 0, 0.04);
      display: flex;
      flex-direction: column;
      padding: 6px 10px;

      .van-popover__action {
        margin-bottom: 8px;
        width: 100%;
        color: #333;
        font-size: 26px;
        font-style: normal;
        font-weight: bold;
        line-height: 36px;
        /* 138.462% */
        text-transform: capitalize;

        &:last-child {
          margin-bottom: 0px;
        }

        &-on {
          border-radius: 8px;
          background: #F1E4FF;
        }
      }
    }
  }
}
</style>